

const sleep = (t) => new Promise((r) => setTimeout(r, t));

export function swiperInit() {
	var defaultSettingSwiper = {
		preventInteractionOnTransition: true,
		rewind: true,
		speed: 1205,
		loop: false,
		observer: true,
		observeParents: true,
		autoplay: {
			delay: 4000,
			pauseOnMouseEnter: true,
		},
		lazy: {
			loadPrevNext: true,
		},
	};




	$(".logo-swiper .swiper").each(function (index) {
		var $this = $(this);
		$this.addClass("logo-swiper-init-" + index);
		var swiper = new Swiper(".logo-swiper-init-" + index, {
			loop: true,
			speed: 1000,
			autoplay: {
				delay: 3000,
				disableOnInteraction: false,
			},
			slidesPerView: 1,
		});
	});



	var partnerSwiper = new Swiper(".partner-swiper .swiper", {
		loop: true,
		speed: 4000,
		autoplay: {
			delay: 0,
			disableOnInteraction: false,
		},
		breakpoints: {
			320: {
				slidesPerView: 2,
			},
			576: {
				slidesPerView: 3,
			},
			768: {
				slidesPerView: 4,
			},
			1024: {
				slidesPerView: 6,
			},
			1200: {
				slidesPerView: 8,
			},
		},
	});


	var primarySwiper = new Swiper(".primary-banner .swiper", {
		// Optional parameters
		slidesPerView: 1,
		observer: true,
		observeParents: true,
		preventInteractionOnTransition: true,
		speed: 1205,
		autoplay: false,
		lazy: {
			loadPrevNext: true,
		},
		rewind: true,
		loop: false,
		pagination: {
			el: ".primary-banner .swiper-pagination",
			type: "bullets",
			clickable: true,
			renderBullet: function (index, className) {
				return `<span class="${className}" data-index="${index}"></span>`;
			},
		},
		on: {
			activeIndexChange: function () {
				const cIdx = this.realIndex + 1;
				$('.primary-banner .current-num').text(cIdx);
			},
		}
	});


	var tabSwiper = new Swiper('.swiper-tab-nav .swiper', {
		loop: false,
		speed: 1000,
		autoplay: false,
		grabCursor: true,
		centeredSlides: true,
		slideToClickedSlide: true,
		slidesPerView: 'auto',
		observer: true,
		observeParents: true,
		navigation: {
			nextEl: '.swiper-tab-nav .next',
			prevEl: '.swiper-tab-nav .prev',
		},

	})

	try {
		tabSwiper.slideTo(2);
	} catch (error) {

	}

	var historyThumb = new Swiper(".history-thumb .swiper", {
		loop: false,
		speed: 1000,
		autoplay: false,
		grabCursor: true,
		centeredSlides: true,
		slideToClickedSlide: true,
		slidesPerView: 'auto',
	});
	var historyMain = new Swiper(".history-main .swiper", {
		spaceBetween: 10,
		centeredSlides: true,
		speed: 1205,
		slidesPerView: 1,
		loop: false,
		autoplay: {
			delay: 5000,
			pauseOnMouseEnter: false,
			disableOnInteraction: false,
		},
		lazy: {
			loadPrevNext: true,
		},
		navigation: {
			nextEl: ".history-main .next",
			prevEl: ".history-main .prev ",
		},
	});

	try {
		historyThumb.slideTo(2);
		historyThumb.controller.control = historyMain;
		historyMain.controller.control = historyThumb;
	} catch (error) {

	}

	var productThumb = new Swiper(" .product-thumb .swiper", {
		spaceBetween: 20,
		breakpoints: {
			200: {
				slidesPerView: 3,
			},
			1024: {
				slidesPerView: 4,
				spaceBetween: 20,
			},
			1200: {
				slidesPerView: 4,
				spaceBetween: 20,
			},
		},
		speed: 500,
		lazy: {
			loadPrevNext: true,
		},
	});
	var productMain = new Swiper(".product-main .swiper", {
		spaceBetween: 10,
		centeredSlides: true,
		speed: 1205,
		autoplay: {
			delay: 3000,
			pauseOnMouseEnter: false,
			disableOnInteraction: false,
		},
		lazy: {
			loadPrevNext: true,
		},
		navigation: {
			nextEl: ".product-thumb .next",
			prevEl: ".product-thumb .prev ",
		},
		thumbs: {
			swiper: productThumb,
		},
	});
	var productTab = new Swiper(".about-tab-nav .swiper", {
		preventInteractionOnTransition: true,
		observer: true,
		observeParents: true,
		speed: 1205,
		loop: false,
		autoplay: false,
		slideToClickedSlide: true,
		lazy: {
			loadPrevNext: true,
		},
		slidesPerView: "auto",
		navigation: {
			nextEl: ".about-tab-nav .next",
			prevEl: ".about-tab-nav .prev",
		},

	});
	$(".init-swiper .swiper").each(function (index) {
		var $this = $(this);
		$this.addClass("swiper-init-" + index);
		$this
			.parents(".init-swiper")
			.find(".prev")
			.addClass("prev-nav-" + index);
		$this
			.parents(".init-swiper")
			.find(".next")
			.addClass("next-nav-" + index);
		$this
			.parents(".init-swiper")
			.find(".swiper-pagination")
			.addClass("pagination-inst-" + index);

		var swiper = new Swiper(".swiper-init-" + index, {
			...defaultSettingSwiper,
			slidesPerView: "auto",
			observer: true,
			observeParents: true,
			navigation: {
				nextEl: ".next-nav-" + index,
				prevEl: ".prev-nav-" + index,
			},
			pagination: {
				el: ".pagination-inst-" + index,
				type: "bullets",
				clickable: true,
				dynamicMainBullets: 1,
			},
		});
	});
}